<template>
  <v-app>
    <v-layout fill-height align-center justify-center>
      <v-row :style="{ height: '100%' }" no-gutters>
        <v-col cols="12" md="4" lg="4">
          <v-card
            height="100%"
            width="100%"
            elevation="0"
            :class="`rounded-0 d-flex ${
              isMobile ? 'align-center' : 'align-end'
            }`"
            color="primary"
            :style="{
              'background-size': 'cover',
              'background-position': `center ${isMobile ? 'top' : 'center'}`,
              'background-image': `${
                isMobile
                  ? 'linear-gradient(rgba(65, 100, 227, 0.6),rgba(2, 21, 120, 0.9))'
                  : 'linear-gradient(rgba(65, 100, 227, 0.4), rgba(6, 8, 16, 0.98))'
              },url(${require('../assets/login_bg.jpg')})`,
            }"
          >
            <div
              :class="`rounded-sm pa-2 text-lg-h3 text-md-h4 text-uppercase font-weight-bold white--text ${
                isMobile ? 'text-center text-h5' : 'text-left mb-1 ml-1'
              }`"
              :style="{
                width: '100%',
              }"
            >
              Trabajamos
              <br v-show="!isMobile" />
              con sentido
              <br v-show="!isMobile" />
              humano
            </div>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="8"
          lg="8"
          :class="`d-flex justify-center align-center ${
            isMobile ? 'pt-0 pb-12' : ''
          }`"
          :style="{
            position: 'relative',
            background: `rgba(226, 233, 255, 0.6)`,
          }"
        >
          <v-card
            class="special-shadow col-11 col-sm-8 col-md-8 col-lg-7 col-xl-6 pt-0"
            :height="isMobile ? 'auto' : '90%'"
            :max-height="isMobile ? '100%' : '500'"
            :loading="card_load"
            :disabled="card_load"
          >
            <div
              class="col-12 pa-0 px-0 d-flex flex-column fill-height justify-center pt-3"
            >
              <v-img
                :src="require('../assets/logo.png')"
                max-height="80"
                contain
              ></v-img>
              <v-card-title>Consulta de resultados</v-card-title>
              <v-card-text>
                <v-text-field
                  label="Identificación"
                  type="text"
                  outlined
                  clearable
                  v-model="form.id"
                  prepend-inner-icon="mdi-account-circle-outline"
                  :error="error.id"
                  @input="error.id = false"
                ></v-text-field>
                <v-text-field
                  label="Contraseña"
                  outlined
                  clearable
                  prepend-inner-icon="mdi-lock-outline"
                  :append-icon="
                    show_pass ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                  "
                  :type="show_pass ? 'text' : 'password'"
                  @click:append="show_pass = !show_pass"
                  v-model="form.clave"
                  :error="error.clave"
                  @input="error.clave = false"
                ></v-text-field>
                <v-select
                  label="Año de estudio"
                  prepend-inner-icon="mdi-calendar-search"
                  :items="tiempo_estudio"
                  outlined
                  hide-details
                  v-model="form.ano_estudio"
                ></v-select>
              </v-card-text>
              <v-card-actions class="pb-0">
                <v-spacer />
                <v-btn
                  depressed
                  color="primary"
                  class="white--text px-5 mr-2"
                  large
                  :block="isMobile"
                  @click="ingresar"
                >
                  Consultar
                  <v-icon right>mdi-magnify</v-icon>
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
          <div
            class="caption grey--text text--lighten-1 text-center"
            :style="{
              position: 'absolute',
              bottom: '3px',
            }"
          >
            Todos los derechos reservados
            <br />
            <b class="text-uppercase">Prosoft SAS • 2020</b>
          </div>
        </v-col>
      </v-row>
    </v-layout>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
      show_pass: false,
      tiempo_estudio: [],
      form: {
        id: null,
        clave: null,
        ano_estudio: null,
      },
      error: {
        id: false,
        clave: false,
        ano_estudio: false,
      },
      card_load: false,
    }
  },
  created() {
    this.form.ano_estudio = new Date().getFullYear().toString()
    for (let i = 2018; i <= parseInt(this.form.ano_estudio); i++){
      this.tiempo_estudio.push(i.toString())
    }
    console.log(this.form.ano_estudio, "AÑO ACTUAL")

    var $this = this
    this.responsive(this.$vuetify.breakpoint.name)
    this.$watch('$vuetify.breakpoint.name', (e) => {
      $this.responsive(e)
    })
  },
  methods: {
    ingresar() {
      var formulario = this.form

      if (!formulario.id) {
        this.error.id = true
        this.$emit('msj', 'Ingresa un número de identificación')
      } else if (!formulario.clave) {
        this.error.clave = true
        this.$emit('msj', 'Ingresa una contraseña')
      } else {
        this.card_load = true
        let regExp = /[a-zA-Z]/g;
        let id_paci = "" 

        if (regExp.test(formulario.id)) id_paci = formulario.id.padStart(15, ' ')
        else id_paci = formulario.id.padStart(15, '0')

        this.postData('INDEX', {
          usuario: id_paci,
          clave: formulario.clave,
          ano_rx: formulario.ano_estudio.slice(2, 4),
        })
          .then((data) => {
            this.card_load = false
            let contenido = JSON.stringify(data.DATA[0])
            console.log(contenido)
            sessionStorage.auth = btoa(contenido)
            location.reload()
          })
          .catch((err) => {
            console.error(err)
            this.card_load = false
            this.$emit(
              'msj',
              err.MENSAJE || 'Ha ocurrido un error durante la consulta',
            )
          })
      }
    },
    responsive(e) {
      switch (e) {
        case 'xs':
        case 'sm':
          this.isMobile = true
          break
        case 'md':
        case 'lg':
        case 'xl':
          this.isMobile = false
          break
      }
    },
  },
}
</script>
